<template>
  <el-row>
    <el-col class="base-cell" :span="5">
      <div class="lable">广告组合：</div>
      <div class="value">{{ detailsData.portfolioName  | defaultShow}}</div>
    </el-col>
    <!-- <el-col class="base-cell" :span="5">
      <div class="lable">品牌：</div>
      <div class="value">{{ detailsData.brandRegistryName | defaultShow }}</div>
    </el-col> -->
    <el-col class="base-cell" :span="5">
      <div class="lable">开始时间（当地市场时间）：</div>
      <div class="value">{{ convertToDate(forms.startDate) }}</div>
    </el-col>
    <el-col class="base-cell" :span="5">
      <div class="lable">结束时间（当地市场时间）：</div>
      <div class="value">{{ convertToDate(forms.endDate) | defaultShow }}</div>
    </el-col>
    <el-col class="base-cell" :span="4">
      <div class="lable">预算：</div>
      <div class="value">{{ publicObj.SB.currencySymbol }}{{ forms.budget }}/ {{ forms.budgetType == 1 ? "日" : "总" }}</div>
    </el-col>
  </el-row>
</template>

<script>
import { convertToDate } from '@/utils/date.util'
export default {
  name: 'add-base',
  inject: ['getForms', 'getDetailsData', 'getPublicObj'],
  props: {},
  data() {
    return {
      convertToDate,
      forms: {},
    };
  },
  components: {},
  methods: {},
  computed: {
    publicObj() {
      return this.getPublicObj()
    },
    detailsData() {
      return this.getDetailsData()
    }
  },
  created() {
    let { addBase } = this.getForms()
    this.forms = addBase
  },
};
</script>

<style scoped lang='scss'>
.base-cell {
  font-size: 12px;
  display: flex;
  .lable {
    color: #666;
  }
  .value {
    color: #333;
  }
}
</style>